import styled from 'styled-components';

export const SecaoBotoes = styled.section`
  padding: 0 0 16px;

  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 8px;

  & > * {
    flex: 1;
  }
`;

export const SecaoPagina = styled.section`
  ul,
  li {
    margin: 0;
    padding: 0;
  }

  li {
    list-style-type: none;
  }
`;

export const FuncionalidadeContainer = styled.div`
  *:focus {
    outline: none;
  }

  display: flex;
  flex-direction: column;
  margin-bottom: 25px;

  .negrito {
    font-weight: bold;
  }

  h2 {
    margin-top: 24px;
  }

  .acoes {
    button {
      margin-left: 8px;
      background-color: transparent;
      border: none;
      cursor: pointer;

      :hover {
        color: #f26522;
      }
    }
  }
`;
